import { render, staticRenderFns } from "./proceso-ingreso.vue?vue&type=template&id=15675b92&"
import script from "./proceso-ingreso.vue?vue&type=script&lang=js&"
export * from "./proceso-ingreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports